import React, { useEffect, useState } from "react";
import axiosInstance from "../../config/axiosInterceptor";

const LevelRequiredEditor = () => {
  const [loading, setLoading] = useState(true);
  const [level, setLevel] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [docId, setDocId] = useState("");
  const [newLevel, setNewLevel] = useState(0);
  const [statusMsg, setStatusMsg] = useState("");

  useEffect(() => {
    fetchLevel();
    // eslint-disable-next-line
  }, []);

  const fetchLevel = async () => {
    setLoading(true);
    setStatusMsg("");
    try {
      const res = await axiosInstance.get(`${process.env.REACT_APP_BASEURL1}/admin/livetime/getlivetime`);
      if (res.data.success && res.data.details) {
        setLevel(res.data.details.levelRequiredToPlayGame || 0);
        setNewLevel(res.data.details.levelRequiredToPlayGame || 0);
        setDocId(res.data.details._id);
      }
      
    } catch (e) {
      setStatusMsg("Error loading value");
    }
    setLoading(false);
  };

  const handleEdit = () => setEditMode(true);

  const handleCancel = () => {
    setEditMode(false);
    setNewLevel(level);
    setStatusMsg("");
  };

  const handleSubmit = async () => {
    setStatusMsg("Updating...");
    try {
      const res = await axiosInstance.put(`${process.env.REACT_APP_BASEURL1}/admin/livetime/updateLevelRequired/${docId}`, {
        levelRequiredToPlayGame: newLevel,
      });
      if (res.data.success) {
        setLevel(res.data.data.levelRequiredToPlayGame);
        setStatusMsg("Updated successfully!");
        setEditMode(false);
      } else {
        setStatusMsg("Failed to update");
      }
    } catch (e) {
      setStatusMsg("Update failed");
    }
  };

  return (
    <div style={{
      margin: "50px auto", maxWidth: 420, background: "#fff",
      borderRadius: 14, boxShadow: "0 6px 32px #0002", padding: 36,
      fontFamily: "Inter, Segoe UI, Arial, sans-serif"
    }}>
      <h2 style={{
        textAlign: "center", marginBottom: 26, color: "#222", letterSpacing: 0.5
      }}>Level Required To Play Game</h2>

      <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
        <input
          type="number"
          min={0}
          value={editMode ? newLevel : level}
          readOnly={!editMode}
          onChange={e => setNewLevel(Number(e.target.value))}
          style={{
            width: 120, fontSize: 20, textAlign: "center", border: editMode ? "1px solid #1677ff" : "1px solid #ddd",
            borderRadius: 8, background: editMode ? "#f4faff" : "#f8f8f8", padding: 10, fontWeight: 600
          }}
        />
        {!editMode && (
          <button
            onClick={handleEdit}
            style={{
              background: "#1677ff", color: "#fff", border: "none",
              borderRadius: 6, padding: "8px 20px", fontWeight: 600, fontSize: 16,
              boxShadow: "0 2px 8px #1677ff22", cursor: "pointer"
            }}
          >Edit</button>
        )}
        {editMode && (
          <>
            <button
              onClick={handleSubmit}
              style={{
                background: "#52c41a", color: "#fff", border: "none",
                borderRadius: 6, padding: "8px 20px", fontWeight: 600, fontSize: 16,
                marginRight: 8, boxShadow: "0 2px 8px #52c41a22", cursor: "pointer"
              }}
            >Submit</button>
            <button
              onClick={handleCancel}
              style={{
                background: "#ff7875", color: "#fff", border: "none",
                borderRadius: 6, padding: "8px 20px", fontWeight: 600, fontSize: 16,
                boxShadow: "0 2px 8px #ff787522", cursor: "pointer"
              }}
            >Cancel</button>
          </>
        )}
      </div>
      <div style={{ marginTop: 18, color: "#888", fontSize: 15 }}>
        {loading ? "Loading..." : statusMsg}
      </div>
    </div>
  );
};

export default LevelRequiredEditor;
